import { render, staticRenderFns } from "./CO2BenefitQuestion.vue?vue&type=template&id=1b2c28ba&scoped=true&"
import script from "./CO2BenefitQuestion.vue?vue&type=script&lang=ts&"
export * from "./CO2BenefitQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c28ba",
  null
  
)

export default component.exports